export const COLORS = {
    dark: '#0c0c0c',
    darkLighter: '#161617',
    faint: '#22222b',
    faintPurple: '#56566f',
    lightPurple: '#9494b7',
    purple: '#3e3ca2',
}